<template>
  <div class="page-root" id="Export-root">
    <div class="jumbotron h-100 pt-5" id="Export-jumbotron">
      <div class="container" id="Export-container">
        <h1 class="page-title">{{ 'EXPORT' | translate('nav') }}</h1>
        <form id="Export-form">
          <div class="row mb-4" id="Export-formRow">
          <div class="col-4" id="Export-formCol-batchName">
            <label for="batchId_dropdown" id="Export-batchId-dropdown-label">{{ 'BATCH_ID' | translate }} <span>*</span></label>
            <select class="form-control" v-model="selectedBatchId" id="batchId_dropdown">
              <option v-for="batchId of batchIds" :key="batchId" :id="'Export-batchId-dropdown-option-'+batchId"> {{ batchId }}</option>
            </select>
          </div>
          <div class="col-4" id="Export-formCol-caseStatus">
            <label for="policyCaseStatus_dropdown" id="Export-caseStatus-dropdown-label">{{ 'POLICY_CASE_STATUS' | translate }} <span>*</span></label>
            <select class="form-control" v-model="selectedPolicyCaseStatus" name="status"
                    id="policyCaseStatus_dropdown">
              <option v-for="status in policyCaseStatuses" :key="status" :value="status" :id="'Export-caseStatus-dropdown-option-'+status">
                {{ status | translate('status') }}
              </option>
            </select>
          </div>

          <div class="col-4" id="Export-formCol-productLine">
            <label for="productLine_dropdown" id="Export-productLine-dropdown-label">{{ 'PRODUCT_LINE' | translate }} <span>*</span></label>
            <select class="form-control" v-model="selectedProductLine" id="productLine_dropdown">
              <option v-for="productLine in sortedProductLines" :key="productLine.name" :value="productLine.name" :id="'Export-productLine-dropdown-option-'+productLine.name">{{ productLine.description }}</option>
            </select>
          </div>

          </div>
          <div class="row mb-4" id="Export-buttonDivRow">
            <div class="col-2" id="Export-buttonDivCol">
              <button type="button" class="btn btn-block btn-primary" id="exportButton"
                      :disabled="!requiredFielsdsNotEmpty() || submitting || disableButtonAfterSuccess"
                      :title="requiredFielsdsNotEmpty() ? '' : 'SELECT_ALL_FIELDS' | translate "
                      @click="executeAction">{{ 'SUBMIT' | translate }}</button>
            </div>
            <div class="col" id="Export-checkboxDivCol">
              <div class="custom-control alternative custom-checkbox mt-2 mr-3 pull-left" id="Export-customCheckboxDiv">
                <input type="checkbox" class="custom-control-input" id="closeExported_checkbox"
                      v-model="selectedCloseCheckbox">
                <label class="custom-control-label" for="closeExported_checkbox" id="Export-customCheckboxDiv-label">{{ 'CLOSE_EXPORTED_CASES' | translate }}</label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import RestService from '../../service/RestService.js';
import GeneralConfigService from '../../service/GeneralConfigService';

export default {
  data: function() {
    return {
      rest: this.initRestService(),
      batchIds: new Set([]),
      policyCaseStatuses: [],
      productLines: {},
      selectedBatchId: null,
      selectedPolicyCaseStatus: null,
      selectedProductLine: null,
      selectedCloseCheckbox: false,
      submitting: false,
      disableButtonTime: 3000,
      disableButtonAfterSuccess: false
    }
  },
  async beforeMount() {
    await this.init();
  },
  computed: {
    sortedProductLines: function () {
      if (this.productLines.length) {
        return this.productLines.sort();
      }
    }
  },
  methods: {
    initRestService: function() {
      return new RestService();
    },
    async init() {
      // load product lines
      this.productLines = await GeneralConfigService.getAllProductLines();
      // load batch IDs
      this.batchIds = await GeneralConfigService.getPolicyCaseBatchIds();
      // load all poliycase statuses different than historical
      this.policyCaseStatuses = await GeneralConfigService.getPolicyCaseStatuses();
    },
    executeAction: function() {
      this.submitting = true;
      if (this.requiredFielsdsNotEmpty()) {
        const vm = this;
        this.rest.export(this.selectedBatchId, this.selectedPolicyCaseStatus, this.selectedProductLine, this.selectedCloseCheckbox)
          .then((result) => {
            vm.submitting = false;
            setTimeout(() => {
              vm.cmLoaded = true;
              vm.setSuccessMessage('Export transformatie is gestart.');
            }, 300);
          }, (error) => {
            vm.submitting = false;
            vm.setErrorMessage('Het is niet gelukt om transformatie uit te voeren. \n' + error.response.data);
          });
      }
    },
    setSuccessMessage(message) {
      this.disableButtonAfterSuccess = true;
      this.$notify({ type: 'alert-success', text: message });
      setTimeout(() => {
        this.disableButtonAfterSuccess = false;
      }, this.disableButtonTime);
    },
    setErrorMessage: function(message) {
      this.$notify({ type: 'alert-danger', duration: -1, text: message });
    },
    requiredFielsdsNotEmpty() {
      return (this.selectedBatchId && this.selectedPolicyCaseStatus && this.selectedProductLine);
    }
  }
}
</script>

<style scoped>
  .delete-icon {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/export/Export.vue